import { z } from 'zod';
import { PRIORITY_MAX } from '../limits.js';
import { IsoTimestampSchema, SchemaVersionSchema } from './shared.js';
export const SystemConfigTypeSchema = z.enum([
    'founder_list',
    'feature_flags',
    'notification_defaults_by_role',
    // QBO OAuth tokens persist as a system_config row with this configType
    // (see packages/backend/src/repositories/qbo-oauth.ts). Kept in sync so the
    // enum is a faithful catalog of every config type actually written.
    'qbo_oauth_tokens',
    // The role-assignment reconcile job persists its run-state under this
    // configType (see jobs/handlers/role-assignment-reconcile.ts) — included so
    // the enum stays a faithful catalog of every persisted config type.
    'role_assignment_reconcile',
]);
export const SystemConfigSchema = z.object({
    id: z.string(),
    type: z.literal('system_config'),
    configType: SystemConfigTypeSchema,
    schemaVersion: SchemaVersionSchema,
    payload: z.unknown(),
    updatedAt: IsoTimestampSchema,
    updatedBy: z.string(),
    version: z.number().int().positive(),
});
/** founder-list payload (used by Phase 2 auto-assignment). */
export const FounderListRuleSchema = z.object({
    ruleId: z.string(),
    // QA 2026-10-01 F-08 — same ceiling as PUT /admin/founder-list.
    priority: z.number().int().positive().max(PRIORITY_MAX),
    matchType: z.enum(['exact_email', 'email_domain', 'company_name', 'default']),
    matchValue: z.string(),
    assignToRepEmail: z.string(),
    note: z.string().optional(),
    enabled: z.boolean(),
    createdAt: IsoTimestampSchema,
    createdBy: z.string(),
});
export const FounderListPayloadSchema = z.object({
    rules: z.array(FounderListRuleSchema),
});
//# sourceMappingURL=system-config.js.map